import { render } from "./ConfirmDialogue.vue?vue&type=template&id=923dee4c&scoped=true"
import script from "./ConfirmDialogue.vue?vue&type=script&lang=js"
export * from "./ConfirmDialogue.vue?vue&type=script&lang=js"

import "./ConfirmDialogue.vue?vue&type=style&index=0&id=923dee4c&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-dielnimmer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-923dee4c"]])

export default __exports__